// Builds the task docs the web app writes to Actions/{sn}/Logs, so every
// screen sends the same fields in the same order (TESTING_PLAN.md Phase 2).
// Write them with enqueueTask (./enqueueTask.js).
//
// Like robotContract.js, this module has no Firebase imports, so Node scripts
// and the integration tests can require() it too.

import { COMMANDS, validateTask } from './robotContract.js';

// The robot app never reads the fetch wait time, but it expects the argument.
export const DEFAULT_FETCH_WAIT_SECONDS = '60';

// The description shown in the task lists, per command.
const DESCRIPTIONS = {
  goto: ({ location }) => `Going to ${location}`,
  come_here: ({ location }) => `Come here to ${location}`,
  escort: ({ name }) => `Escorting ${name}`,
  fetch: ({ item, from, to }) => `Fetching ${item} from ${from} to ${to}`,
  deliver: ({ item, from, to }) => `Deliver ${item} from ${from} to ${to}`,
  video: () => 'Show Video',
  message: () => 'Display Message',
  announcement: () => 'Announce Message',
  qr: () => 'Show QR',
};

const DEFAULTS = {
  fetch: { waitSeconds: DEFAULT_FETCH_WAIT_SECONDS },
};

// Returns a complete upcoming task doc. args is keyed by the argument names in
// COMMANDS (e.g. { item, from, to } for fetch), and buildTask puts them in the
// order the robot expects. Throws if the doc would break the contract.
export function buildTask(command, args, { userName, robotName, now = new Date() }) {
  const spec = COMMANDS[command];
  if (!spec || !DESCRIPTIONS[command]) throw new Error(`The web app can't send "${command}" tasks`);

  const values = { ...DEFAULTS[command], ...args };
  const content = [command, ...spec.args.map((name) => values[name])];
  // Leave out trailing optional arguments that weren't given.
  const min = spec.args.length - (spec.optional || 0) + 1;
  while (content.length > min && content[content.length - 1] === undefined) content.pop();

  // A Date is stored as a Timestamp by both the web SDK and firebase-admin.
  const task = {
    by: userName,
    description: DESCRIPTIONS[command](values),
    status: 'upcoming',
    timestamp: now,
    content,
    robot_name: robotName,
    wifi_status: 'Online',
    is_approved: false,
    is_running: false,
  };

  const errors = validateTask(task);
  if (errors.length) throw new Error(`Invalid ${command} task: ${errors.join('; ')}`);
  return task;
}
